import { useCallback } from 'react';
import { setCulture as setCultureRedux } from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import { store } from 'redux/store';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useCulture from '../useCulture';

export default function useCultures(map: CultureIndexAreaMap) {
  const { cultures } = useCulture();

  const setCulture = useCallback((culture: CultureIndexCulture | undefined) => {
    store.dispatch(setCultureRedux({
      id: map.id,
      culture,
    }));
  }, [map]);

  return {
    cultures,
    setCulture,
  };
}
